import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop kanban board. Each .kanban__column-body is a Sortable.
// On drop, posts the new group_field/value to the backend.
export default class extends Controller {
  static targets = ["body"]
  static values = {
    groupField:      String,
    moveUrlTemplate: String  // e.g. /juniors/1/etudes/__id__/move
  }

  connect() {
    this.sortables = this.bodyTargets.map(body => Sortable.create(body, {
      group: "kanban-cards",
      animation: 150,
      ghostClass: "sortable-ghost",
      dragClass:  "sortable-drag",
      onAdd: this._onAdd.bind(this),
      onEnd: this._onEnd.bind(this)
    }))
  }

  disconnect() {
    this.sortables?.forEach(s => s.destroy())
  }

  _onAdd(event) {
    const card = event.item
    const newColumn = event.to.closest(".kanban__column")
    const id = card.dataset.cardId || card.dataset.etudeId
    const value = newColumn?.dataset.kanbanColumnKey
    if (!id || value === undefined) return

    this._move(id, value, newColumn, event.from.closest(".kanban__column"))
  }

  _onEnd(event) {
    // Same-column drag: nothing to persist (no ordering yet).
    if (event.from === event.to) return
  }

  async _move(id, value, newColumn, oldColumn) {
    const url = this.moveUrlTemplateValue.replace("__id__", id)
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrf || ""
      },
      body: JSON.stringify({ group_field: this.groupFieldValue, value: value === "" ? null : value })
    })

    if (!res.ok) {
      alert("La modification n'a pas pu être enregistrée. Annulation du déplacement.")
      window.location.reload()
      return
    }

    this._updateCount(newColumn, +1)
    this._updateCount(oldColumn, -1)
  }

  _updateCount(col, delta) {
    if (!col) return
    const counter = col.querySelector(".kanban__column-count")
    if (!counter) return
    counter.textContent = String(parseInt(counter.textContent || "0", 10) + delta)
  }
}
